var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDobroruLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 67,
    viewBox: "0 0 154 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2566_29888)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    stroke: "currentColor",
    d: "M0 54.3985H6.70414V48.064H24.0829V54.3985L31.1124 54.3333L30.9172 47.9988L30.8521 41.6642H26.4911V22.3995H23.432H19.3965H11.6509H4.55622V28.734V35.9175C4.55622 35.9175 4.68638 40.4234 1.30178 41.7295H0V54.3985ZM11.6509 35.9175V28.734H19.3965V41.7295H10.4793C10.4793 41.7295 11.6509 39.6398 11.6509 35.9175Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    stroke: "currentColor",
    d: "M46.9941 21.8116C54.4793 21.8116 60.4674 27.1014 60.5324 35.395C60.5976 42.905 54.4793 48.9784 46.9941 48.9784C39.5089 48.9784 33.4556 42.905 33.4556 35.395C33.5207 27.885 39.5739 21.8116 46.9941 21.8116ZM46.9941 29.387C43.6745 29.387 41.0059 32.0644 41.0059 35.395C41.0059 38.7255 43.6745 41.403 46.9941 41.403C50.3135 41.403 52.9822 38.7255 52.9822 35.395C52.9822 32.0644 50.3135 29.387 46.9941 29.387Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    stroke: "currentColor",
    d: "M78.9527 23.379C86.0473 23.379 91.8403 29.1257 91.8403 36.1786C91.8403 43.2315 86.0473 48.9782 78.9527 48.9782C67.7574 48.9782 64.503 42.1866 63.9172 32.6522C63.6568 28.3421 64.9586 23.7056 66.0001 21.028C69.1242 13.1915 78.3018 11.363 89.5622 9.07731V16.5221L79.4734 18.9383C79.4734 18.9383 73.6804 20.5056 73.0296 24.8157C74.7871 23.9014 76.8047 23.379 78.9527 23.379ZM78.1717 30.0401C75.0474 30.0401 72.509 32.5869 72.509 35.7215C72.509 38.8562 75.0474 41.403 78.1717 41.403C81.2959 41.403 83.8344 38.8562 83.8344 35.7215C83.8344 32.5869 81.2959 30.0401 78.1717 30.0401Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    stroke: "currentColor",
    d: "M96.8521 59.4923H104.467V46.3008C106.42 47.9334 108.763 48.913 111.367 48.913C117.745 48.913 122.953 42.905 122.953 35.5256C122.953 28.1462 117.745 22.1382 111.367 22.1382C108.763 22.1382 106.42 23.1177 104.467 24.7503V22.3341H96.8521V59.0352V59.4923ZM109.87 29.2563C112.994 29.2563 115.467 31.7379 115.467 35.1991C115.467 38.6602 113.45 41.3376 109.805 41.403C106.68 41.4684 104.272 38.5297 104.272 35.0685C104.272 31.6073 106.746 29.2563 109.87 29.2563Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    stroke: "currentColor",
    d: "M140.396 21.6157C132.911 21.6157 126.923 27.885 126.923 35.395C126.923 42.905 132.976 48.9782 140.462 48.9782C147.946 48.9782 154 42.905 154 35.395C153.935 27.885 147.882 21.6157 140.396 21.6157ZM140.462 41.403C137.142 41.403 134.473 38.7255 134.473 35.395C134.473 32.0644 136.295 29.1911 140.462 29.0605C143.781 28.9298 146.45 32.0644 146.45 35.395C146.45 38.7255 143.781 41.403 140.462 41.403Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    stroke: "currentColor",
    d: "M126.272 13.9099C127.899 13.9099 129.201 12.6037 129.201 10.9711C129.201 9.33853 127.899 8.03244 126.272 8.03244C124.645 8.03244 123.343 9.33853 123.343 10.9711C123.343 12.6037 124.645 13.9099 126.272 13.9099Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    stroke: "currentColor",
    d: "M131.024 13.518H135.059V6.33452C136.361 3.00401 139.55 4.17949 139.55 4.17949V0.195913C139.55 0.195913 137.662 -0.391827 136.296 0.587739C135.71 1.04487 135.254 1.502 134.929 1.95913V0H131.024V13.518Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    stroke: "currentColor",
    d: "M145.212 8.42427V0H141.308V8.75079C141.308 9.66505 141.894 12.9303 145.212 13.6486C148.532 14.3016 150.094 12.0813 150.094 12.0813V13.5833H154V0H150.094V7.83653C149.834 8.62018 149.249 9.99157 147.426 9.99157C145.733 10.0569 145.212 8.42427 145.212 8.42427Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    stroke: "currentColor",
    d: "M37.2307 53.4843V59.3617C37.2307 59.3617 48.1005 65.9574 61.704 65.9574C75.3076 65.9574 87.0887 59.4923 87.0887 59.4923L87.0235 52.8965C86.9585 52.9619 63.2663 67.1983 37.2307 53.4843Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2566_29888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 154,
    height: 67,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDobroruLogo);
export default __webpack_public_path__ + "static/media/dobroruLogo.f4fc656cf679d8f391c116db1c6f1b77765ef5133905602a4540df0846642f1b.svg";
export { ForwardRef as ReactComponent };